import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f28c1ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex -gap-x-4" }
const _hoisted_2 = { class: "flex-none" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "flex-1 flex flex-col justify-between text-gray-800" }
const _hoisted_5 = { class: "text-2xl font-bold mb-4" }
const _hoisted_6 = { class: "py-8" }
const _hoisted_7 = { class: "flex justify-between items-center" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "text-green-600 text-4xl opacity-100" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { key: 1 }

import { reactive, computed } from 'vue';
import { RegionDto } from 'src/api/types';
import dayjs from 'dayjs';


export default /*#__PURE__*/_defineComponent({
  __name: 'SvTimeline',
  props: {
    region: {}
  },
  setup(__props: any) {

const props = __props;

const regions = computed(() => {
  const children = props.region.children
    ?.map((t) => ({
      date: dayjs(t.name),
      year: dayjs(t.name).format('YYYY'),
      month: dayjs(t.name).format('MM'),
      name: t.name,
      title: dayjs(t.name).format('YYYY-MM'),
      summary: t.summary,
    }))
    .sort((x, y) => {
      return x.date.isBefore(y.date) ? -1 : 1;
    });
  const hash: Record<string, boolean> = {};
  const array: string[] = [];
  children?.forEach((item) => {
    if (!hash[item.year]) {
      hash[item.year] = true;
      array.push(item.year);
    }
  });

  return array.map((year) => ({
    year: parseInt(year),
    opacity: 1,
    children: children?.filter((item) => item.year === year),
  }));
});

const THE_YEAR = parseInt(dayjs().format('YYYY'));

const state = reactive({
  min: regions.value?.length ? regions.value[0].year ?? THE_YEAR : THE_YEAR,
  max: regions.value?.length
    ? regions.value[regions.value.length - 1].year ?? THE_YEAR
    : THE_YEAR,
  year: Math.min(
    regions.value?.length
      ? regions.value[regions.value.length - 1].year ?? THE_YEAR
      : THE_YEAR,
    THE_YEAR
  ),
});

// onMounted(() => {
//   state.min = regions.value[0].year;
//   state.max = regions.value[regions.value.length - 1].year;
//   if (state.year > state.max) {
//     state.year = state.max;
//   }
// });

const prevRegions = computed(() => {
  const array = regions.value.filter((t) => t.year < state.year);
  if (array.length === 0)
    return [
      { year: state.min - 2, opacity: 0 },
      { year: state.min - 1, opacity: 0 },
    ];
  if (array.length === 1)
    return [{ year: state.min - 1, opacity: 0 }, array[0]];
  return array.slice(array.length - 2);
});

const currentRegion = computed(() => {
  return (
    regions.value.filter((t) => t.year === state.year)[0] ?? {
      year: 'ERROR',
      opacity: 1,
    }
  );
});

const nextRegions = computed(() => {
  const array = regions.value.filter((t) => t.year > state.year);
  if (array.length === 0)
    return [
      { year: state.max + 1, opacity: 0 },
      { year: state.max + 2, opacity: 0 },
    ];
  if (array.length === 1)
    return [array[0], { year: state.max + 1, opacity: 0 }];
  return array.slice(0, 2);
});

const isFirst = computed(() => state.year === state.min);
const isLast = computed(() => state.year === state.max);

const prev = () => {
  const index = regions.value.findIndex((t) => t.year === state.year);
  if (index > 0) {
    const current = regions.value[index - 1];
    state.year = current.year;
  }
};

const next = () => {
  const index = regions.value.findIndex((t) => t.year === state.year);
  if (index < regions.value.length - 1) {
    const current = regions.value[index + 1];
    state.year = current.year;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_timeline_entry = _resolveComponent("q-timeline-entry")!
  const _component_q_timeline = _resolveComponent("q-timeline")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.region.icon)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "w-8 h-8",
              src: _ctx.region.icon,
              alt: _ctx.region.name
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.region.name), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_q_btn, {
          class: _normalizeClass(`text-green-600 text-4xl opacity-${isFirst.value ? 0 : 1}`),
          icon: "mdi-chevron-left",
          padding: "0",
          round: "",
          onClick: prev
        }, null, 8, ["class"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prevRegions.value, (region) => {
          return (_openBlock(), _createElementBlock("div", {
            key: region.year,
            class: _normalizeClass(`text-2xl opacity-${region.opacity ? 100 : 0}`)
          }, [
            (region.opacity)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "cursor-pointer",
                  onClick: () => (state.year = region.year)
                }, _toDisplayString(region.year), 9, _hoisted_8))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, "ERR"))
          ], 2))
        }), 128)),
        _createElementVNode("div", _hoisted_10, _toDisplayString(currentRegion.value.year), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nextRegions.value, (region) => {
          return (_openBlock(), _createElementBlock("div", {
            key: region.year,
            class: _normalizeClass(`text-2xl opacity-${region.opacity ? 100 : 0}`)
          }, [
            (region.opacity)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "cursor-pointer",
                  onClick: () => (state.year = region.year)
                }, _toDisplayString(region.year), 9, _hoisted_11))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, "ERR"))
          ], 2))
        }), 128)),
        _createVNode(_component_q_btn, {
          class: _normalizeClass(`text-green-600 text-4xl opacity-${isLast.value ? 0 : 1}`),
          icon: "mdi-chevron-right",
          padding: "0",
          round: "",
          onClick: next
        }, null, 8, ["class"])
      ]),
      _createVNode(_component_q_timeline, {
        layout: "loose",
        color: "black"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentRegion.value.children, (child, i) => {
            return (_openBlock(), _createBlock(_component_q_timeline_entry, {
              key: child.name,
              class: "text-gray-600",
              title: child.title,
              side: i % 2 === 0 ? 'left' : 'right'
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((child.summary ?? '').split('\n'), (p, i) => {
                    return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(p), 1))
                  }), 128))
                ])
              ]),
              _: 2
            }, 1032, ["title", "side"]))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})